import React from "react";

const IconDeleteTrash = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 4H3.83333H14.5"
        stroke="#E11900"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83203 4.00065V2.66732C5.83203 2.3137 5.97251 1.97456 6.22256 1.72451C6.4726 1.47446 6.81174 1.33398 7.16536 1.33398H9.83203C10.1857 1.33398 10.5248 1.47446 10.7748 1.72451C11.0249 1.97456 11.1654 2.3137 11.1654 2.66732V4.00065M13.1654 4.00065V13.334C13.1654 13.6876 13.0249 14.0267 12.7748 14.2768C12.5248 14.5268 12.1857 14.6673 11.832 14.6673H5.16536C4.81174 14.6673 4.4726 14.5268 4.22256 14.2768C3.97251 14.0267 3.83203 13.6876 3.83203 13.334V4.00065H13.1654Z"
        stroke="#E11900"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconDeleteTrash;
